/**
 * responsive: ResponsiveType for React-Multi-Carousel
 * This breakpoint is used to determine the number of review cards to display
 * based on the screen width and default review card width -
 * components/ReviewCard/ReviewCard.js
 * */
export const responsive = {
  largeDesktop: {
    breakpoint: { max: 3000, min: 1410 },
    items: 4
  },
  mediumDesktop: {
    breakpoint: { max: 1409, min: 1200 },
    items: 3.1
  },
  desktop: {
    breakpoint: { max: 1199, min: 920 },
    items: 2.5
  },
  tablet: {
    breakpoint: { max: 919, min: 767 },
    items: 2.1
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 2.8
  }
};

export const mobilePillButtonsResponsive = {
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 4
  }
};

/**
 * responsive: ResponsiveType for React-Multi-Carousel
 * This breakpoint is used to determine the number of location tip cards to display
 * based on the screen width and default tip card width -
 * src/screens/LocationProfile/LocationReviews.js
 * */
export const locationProfileResponsive = {
  largeDesktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 2.5
  },
  desktop: {
    breakpoint: { max: 1199, min: 1024 },
    items: 2.2
  },
  largeTablet: {
    breakpoint: { max: 1023, min: 960 },
    items: 2.1
  },
  tablet: {
    breakpoint: { max: 959, min: 580 },
    items: 1.6
  },
  smallTablet: {
    breakpoint: { max: 579, min: 440 },
    items: 1.2
  },
  largeMobile: {
    breakpoint: { max: 439, min: 391 },
    items: 1.1
  },
  mobile: {
    breakpoint: { max: 390, min: 370 },
    items: 1.02
  },
  smallMobile: {
    breakpoint: { max: 369, min: 0 },
    items: 1
  }
};

export const featuredPressResponsive = {
  desktop: {
    breakpoint: { max: 3000, min: 768 },
    items: 5.3
  }
};
